<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="360">
                <v-card>
                    <v-card-title class="subheading" style="border-bottom: solid 1px #eaeaea;">Syndicated Deals Report</v-card-title>
                    <v-card-text>
                    <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        full-width
                        max-width="290"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="date.excel_origin_start_date"
                            label="Payout Start Date"
                            readonly
                            v-on="on"
                            hide-details
                            append-icon="event"
                        ></v-text-field>
                        </template>
                        <v-date-picker 
                        @input="menu1 = false"
                        v-model="date.excel_origin_start_date"></v-date-picker>
                    </v-menu>

                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        full-width
                        max-width="290"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="date.excel_origin_end_date"
                            label="Payout End Date"
                            readonly
                            v-on="on"
                            hide-details
                            append-icon="event"
                        ></v-text-field>
                        </template>
                        <v-date-picker 
                        @input="menu2 = false"
                        v-model="date.excel_origin_end_date"></v-date-picker>
                    </v-menu>

                    </v-card-text>
                    <v-card-actions>
                    <v-btn flat color="blue" text @click="close">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat color="blue" text @click="exportSyndicatedDeals()">Export</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import axios from "axios";
import {URL, config} from '../../../env'
import moment from "moment";
export default {
   props: {
		dialog: {
			type: Boolean,
			default: false,
        },
        tableData: {
			type: Object,
			default: null,
		}
	},
    data() {
        return {
            menu1: false,
            menu2: false,
            date: {
                excel_origin_start_date: null,//moment().startOf('month').format('YYYY-MM-DD'),
                excel_origin_end_date: null,//moment().format("YYYY-MM-DD"),
            }
            
        };
  },
  methods:{
        close(){
            this.$emit('closeDialog')
        },
        exportSyndicatedDeals(){
            let start = this.date.excel_origin_start_date
            let end = this.date.excel_origin_end_date
            let file ="syndicated_deals("+start + ' - ' + end +").xlsx"
            axios({
                url: `${URL}/api/payouts/export_syndicated_deals`,
                method: "POST",
                responseType: "blob", // important
                data: Object.assign(this.tableData , this.date)
            }).then(response => {
                this.$emit('closeDialog')
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", file);
                document.body.appendChild(link);
                link.click();
            }).catch(err=>{
                this.$emit('closeDialog')
            })
        }
  }

}
</script>